import { defineAsyncComponent } from 'vue'
import { PATH_NAME_SPECIAL } from '@/common/resources/router.const'

export const routeAsyncComponent = (handle) => {
  return defineAsyncComponent(handle)
}

export default [
  {
    path: '/special',
    name: PATH_NAME_SPECIAL,
    components: {
      homeBodyContent: routeAsyncComponent(
        () => import('@/pages/special/SpecialHomeView.vue'),
      ),
    },
  },
]
